import { schoolTokenAxios } from "../axios";

const SCHOOL_REPORTING_BASE = process.env.REACT_APP_SCHOOL_REPORTING_BASE;

let zoho_desk_url = `${SCHOOL_REPORTING_BASE}/zoho/zohoDesk`;
let access_url = `${SCHOOL_REPORTING_BASE}/schoolAccess`;

export const getTicket = (params) => {
  return schoolTokenAxios.get(`${zoho_desk_url}/getTicket`, {
    params: params,
  });
};

export const createTicket = (formData) => {
  return schoolTokenAxios.post(`${zoho_desk_url}/createTicket`, formData);
};
export const getTicketDetails = (ticketId) => {
  return schoolTokenAxios.get(`${zoho_desk_url}/tickets/${ticketId}`);
};

export const getTicketConversation = (ticketId) => {
  return schoolTokenAxios.get(
    `${zoho_desk_url}/tickets/${ticketId}/conversations`
  );
};

export const getTicketThreadDetail = (ticketId, threadId) => {
  return schoolTokenAxios.get(
    `${zoho_desk_url}/tickets/${ticketId}/thread/${threadId}`
  );
};

export const getModuleList = () => {
  return schoolTokenAxios.get(`${access_url}/getModuleList`);
};

export const getScreenNameList = () => {
  return schoolTokenAxios.get(`${access_url}/getScreenNameList`);
};
